import Splide from '@splidejs/splide';
import {AutoScroll} from '@splidejs/splide-extension-auto-scroll';
( function( app ) {
  const COMPONENT = {
    init: function() {
      if ( $( '.marquee__splide' ).length ) {
        const prefersReducedMotion = window.matchMedia( '(prefers-reduced-motion: reduce)' ).matches;
        console.log( window.hasMotion );
        $( '.marquee__splide' ).each( function( index, element ) {
          const slider = new Splide( $( element )[0], {
            type: 'loop',
            drag: 'free',
            gap: '2rem',
            arrows: false,
            autoWidth: true,
            pagination: false,
            autoScroll: {
              speed: prefersReducedMotion ? 0 : .75,
              pauseOnFocus: true,
              pauseOnHover: true,
              autoStart: window.hasMotion ? true : false,
            },
          } );

          slider.mount( {AutoScroll} );
        } );
      }
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'marquee', COMPONENT );
} )( app );
